<template>
    <div>
        <div class="row">
            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                <div class="form-group" :class="{required: requiredFields.company === true}">
                    <label class="generic-label">Company</label>
                    <bootstrap-select class="form-control"
                                      v-if="companyOptions.length > 1"
                                      v-model="call.CompanyID"
                                      :options="companyOptions"
                                      :readonly="readOnly"
                    ></bootstrap-select>
                    <input type="text" class="form-control" v-if="companyOptions.length === 1" :value="companyOptions[0].text" readonly>
                </div>
            </div>

            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                <div class="form-group" :class="{required: requiredFields.RequestedBy === true}">
                    <label class="generic-label" for="txtRequestedBy">Requested By</label>
                    <input id="txtRequestedBy" name="txtRequestedBy" type="text" placeholder="Requested By" class="form-control generic-input"
                           v-model="call.RequestedBy"
                           :required="requiredFields.RequestedBy === true"
                           :readonly="readOnly"
                    >
                </div>
            </div>

            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                <div class="form-group" :class="{required: requiredFields.RequestedPhone === true}">
                    <label class="generic-label" for="txtRequestedPhone">Phone #</label>
                    <input id="txtRequestedPhone" name="txtRequestedPhone" maxlength="15" type="tel" placeholder="Phone #" class="form-control generic-input"
                           v-model="call.RequestedPhone"
                           :required="requiredFields.RequestedPhone === true"
                           :readonly="readOnly"
                    >
                </div>
            </div>

        </div>
    </div>
</template>

<style lang="scss" scoped>

</style>

<script>
    export default {

        props: {
            call: Object,
            requiredFields: Object,
            companies: Array,
            readOnly: Boolean,
        },

        data() {
            return {
                companyId: null,

                // companyOptions: [
                //     { value: null, text: '- Select a Company -', disabled: true },
                //     { value: 1, text: 'Tow Company 1' },
                //     { value: 2, text: 'Tow Company 2' },
                //     { value: 3, text: 'Tow Company 3' },
                //     { value: 4, text: 'Tow Company 4' },
                // ],
            };
        },

        computed: {

            companyOptions() {
                let options = [];

                this.companies.forEach(company => {
                    options.push({
                        value: company.CompanyID,
                        text: company.CompanyName,
                    });
                });

                return options;
            },

        },

        mounted() {
            if (this.companies.length === 1) {
                this.call.CompanyID = this.companies[0].CompanyID;
            }
        },

    }
</script>

